import * as React from "react";
import {observer} from "mobx-react";
import type {Type} from "../../../../../data/models/Type";
import type {XyiconFeature} from "../../../../../generated/api/base";
import {TypeForm} from "./form/TypeForm";

interface ITypeDetailsContentProps {
	readonly selected: Type[];
	readonly fieldsFeature: XyiconFeature;
}

interface ITypeDetailsContentState {}

@observer
export class TypeDetailsContent extends React.Component<ITypeDetailsContentProps, ITypeDetailsContentState> {
	constructor(props: ITypeDetailsContentProps) {
		super(props);
		this.state = {};
	}

	public override render() {
		const {selected, fieldsFeature} = this.props;
		const type = selected[0];

		return (
			<>
				{selected.length === 0 && <div className="noData">Please select a type.</div>}
				{selected.length === 1 && (
					<TypeForm
						type={type}
						fieldsFeature={fieldsFeature}
						avatar={true}
					/>
				)}
			</>
		);
	}
}
